import { path } from 'ramda'

export const BOARD_PATH = ['board']
export const boardSelector = path(BOARD_PATH)
